import React, { Component } from 'react';

class CardBaseInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardType: undefined,
      touched: false,
      error: undefined,
    };

    this.handleBlurInput = this.handleBlurInput.bind(this);
  }

  setCardType(cardType) {
    this.setState({ cardType });
  }

  setInputTouched(touched) {
    this.setState({ touched });
  }

  setError(error) {
    this.setState({ error });
  }

  handleBlurInput(props = {}) {
    return e => {
      props.onBlur && props.onBlur(e);
      this.setInputTouched(true);
    };
  }
}

export default CardBaseInput;
